import { API_AWARD, API_PROJECT, API_SP_AGREEMENTS, FORM_SUBMISSION_TYPES } from "globals/constants";
import { spUrl } from "utils";
import { buildSearchParams, request, remove, save } from "utils/proxy";

export const agreements = {
	getList: (searchParams, options) =>
		searchParams.awardId ?
			request(spUrl(`${API_AWARD}/${searchParams.awardId}/agreements${buildSearchParams(searchParams)}`), options) :
			request(spUrl(`${API_PROJECT}/${searchParams.projectId}/agreements${buildSearchParams(searchParams)}`), options),

	getTypes: options => request(spUrl(`${API_SP_AGREEMENTS}/types`), options),

	getStatuses: options => request(spUrl(`${API_SP_AGREEMENTS}/statuses`), options),

	remove: (formType, submissionId, id, options) =>
		remove(spUrl(`${formType === FORM_SUBMISSION_TYPES.PROJECT ? API_PROJECT : API_AWARD}/${submissionId}/agreements/${encodeURIComponent(id)}`), {}, options),

	findAll: search =>
		request(spUrl(`${API_SP_AGREEMENTS}/search?search=${search}&size=20`)),

	create: (body, options) => save(spUrl(API_SP_AGREEMENTS), body, options),

	link: (params, options) =>
		params.awardId ?
			save(spUrl(`${API_AWARD}/${params.awardId}/agreements/${encodeURIComponent(params.agreementId)}`), {}, options) :
			save(spUrl(`${API_PROJECT}/${params.projectId}/agreements/${encodeURIComponent(params.agreementId)}`), {}, options),
};
